import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';

const CloudComputingToolsWorkshop2025 = () => {
    const workshopImages = [
        "1.png ",
        "2.png",
    ];


    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="col-lg-12 ps-lg-4">
                                <div className="how-to-apply">
                                    <h2>
                                        CLOUD COMPUTING TOOLS Workshop
                                    </h2>
                                    <div className='py-2'>
                                        <p>
                                            A two-day workshop on “CLOUD COMPUTING TOOLS” is organised by the IT Department in collaboration with “R TECHNO SOLUTIONS” on 23rd, 24th of August, 2025, for IT BTech IV-I semester students.
                                        </p>
                                    </div>

                                    <div className="css-script-ads"></div>
                                    <div className="spotlight-group">

                                        <div className="row">
                                            {workshopImages.map((img, index) => (
                                                <div key={index} className="col-md-6 mb-3 mb-lg-4">
                                                    <a
                                                        className="spotlight"
                                                        href={`https://admin.swec.ac.in/assetsswec/img/Cloud-Computing-Tools-Workshop-2025/${img}`}
                                                    >
                                                        <img
                                                            src={`https://admin.swec.ac.in/assetsswec/img/Cloud-Computing-Tools-Workshop-2025/${img}`}
                                                            alt={`Cloud-Computing-Tools Workshop 2025 Image ${index + 1}`}
                                                            className="img-responsive center-block"
                                                        />
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default CloudComputingToolsWorkshop2025;
